export enum DetailView {
	DETAILS = 'details',
	JSON = 'json',
}
